/**
 * Components: Wrapper component.
 *
 * @since 3.11.0
 */

/**
 * External dependencies
 */
import styled from 'styled-components';

/**
 * @inheritDoc
 */
const Wrapper = styled.div`
	display: inline-block;
	position: relative;
	height: 16px;
`;

// Finally export the `Wrapper`.
export default Wrapper;
